import { ExtendableError } from '@seneca/client-library';

/**
 * Typed error for forbidden responses on fetching school entities
 * @param {string} schoolId the school id
 */
export default class ForbiddenAccessToSchoolEntitiesError extends ExtendableError {
  schoolId: string;

  constructor(schoolId: string) {
    super(
      `Forbidden access to externally managed school entities. ${schoolId}`
    );

    this.schoolId = schoolId;
  }
}
